export default __webpack_public_path__ + "static/livecasts-ce3fa90a35076bca6be3821d40e1c9d3.jpg";